import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    columnNameSelect: {
      margin: 0,
      width: '100%',
    },

    menuList: {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderTop: 0,
      borderTopRightRadius: 0,

      '& ul': {
        padding: 0,
      },
    },

    menuItem: {
      paddingBlock: 8,
      fontSize: '1.4rem',

      '&:last-child': {
        borderBottom: 'none',
      },

      '&.Mui-selected': {
        color: '#727970',
        backgroundColor: 'transparent',
      },
    },

    redefineButton: {
      margin: 0,
      width: 'max-content',
      color: theme.palette.text.secondary,
      fontSize: '1.2rem',
      fontWeight: 600,
      gap: '0.8rem',

      '& svg': {
        color: theme.palette.secondary.main,
        fontSize: '1.6rem',
      },

      '& .MuiTouchRipple-root': {
        color: theme.palette.secondary.main,
      },
    },

    inputsHeader: {
      display: 'flex',
      marginBottom: '.4rem',
      paddingRight: '7.2rem',

      '& > p': {
        width: '100%',
        fontWeight: 600,
        fontSize: '1.2rem',
        color: theme.palette.text.secondary,
      },
    },

    mapContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.7rem',

      height: '100%',
      width: '100%',
      overflow: 'hidden',

      '& > p': {
        fontSize: '1.2rem',
        fontWeight: 600,
        color: theme.palette.text.secondary,
      },

      '& > div': {
        backgroundColor: '#F4F4F4',
        border: `solid 1px ${theme.palette.secondary.light}`,
        borderRadius: 4,
      },
    },

    marker: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      background: 'none',

      '& > label': {
        textAlign: 'center',
        lineHeight: '1.6rem',
        cursor: 'pointer',

        fontSize: theme.typography.body1.fontSize,
        fontFamily: theme.typography.body1.fontFamily,
      },
    },
  }),
)
